export default {
  chunkMutation(stateArray, array) {
    const chunkSize = 10000;

    if (array.length <= chunkSize) {
      stateArray.push(...array);

      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);

        setTimeout(() => {
          stateArray.push(...chunk);

          if (chunk.length <= chunkSize && (i + chunk.length) === array.length) {
            resolve();
          }
        });
      }
    });
  },
};
